import React from 'react';
import { DownloadIcon } from './Icons';

const EditedImageCard = ({ originalImage, editedImage, responseText, onImageClick }) => {
    const handleDownload = () => {
        // Create a temporary link element
        const link = document.createElement('a');
        link.href = editedImage;
        link.download = `edited-image-${Date.now()}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="bg-[rgba(var(--color-surface-rgb),0.4)] backdrop-blur-lg border border-white/20 rounded-2xl p-6 shadow-xl animate-fade-in-up">
            <h2 className="text-3xl font-bold text-center text-red-800 mb-8">النتيجة النهائية</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
                {/* Original Image */}
                <div>
                    <h3 className="text-xl font-bold text-stone-800 mb-3 text-center">الصورة الأصلية</h3>
                    <div className="grid grid-cols-1 gap-2">
                        <img
                            src={originalImage}
                            alt="Original"
                            className="rounded-lg shadow-md border-2 border-stone-300 w-full h-full object-cover cursor-pointer hover:opacity-80 transition-opacity"
                            onClick={() => onImageClick(originalImage)}
                        />
                    </div>
                </div>

                {/* Edited Image */}
                <div className="text-center">
                    <h3 className="text-xl font-bold text-stone-800 mb-3">بعد التعديل</h3>
                    <div className="mx-auto w-full max-w-full rounded-lg shadow-md border-2 border-red-300 overflow-hidden bg-stone-200/50 aspect-auto">
                        <img
                            src={editedImage}
                            alt="Edited"
                            className="w-full h-full object-contain cursor-pointer"
                            onClick={() => onImageClick(editedImage)}
                        />
                    </div>

                    {/* Download Button */}
                    <button
                        onClick={handleDownload}
                        className="mt-4 px-6 py-3 bg-red-800 text-white font-bold rounded-lg hover:bg-red-700 transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg shadow-red-900/30 flex items-center justify-center gap-2 mx-auto"
                    >
                        <DownloadIcon className="w-5 h-5" />
                        تحميل الصورة
                    </button>
                </div>
            </div>

            {/* Response Text */}
            {responseText && (
                <div className="mt-8 border-t border-stone-400/30 pt-6">
                    <h3 className="font-bold text-stone-800 text-lg mb-2">ملاحظات المساعد الذكي:</h3>
                    <p className="text-stone-600 bg-stone-100/50 p-4 rounded-lg">{responseText}</p>
                </div>
            )}
        </div>
    );
};

export default EditedImageCard;
